import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.mjs';

var formatCurrency = function formatCurrency() {
  var currencyRule = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    format: "#!",
    decimal: ".",
    separator: ",",
    precision: undefined,
    symbol: "",
    currency: ""
  };
  var value = arguments.length > 1 ? arguments[1] : undefined;
  var currency = arguments.length > 2 ? arguments[2] : undefined;
  var _a, _b, _c, _d;
  var symbol = (_a = currencyRule.symbol || currency) !== null && _a !== void 0 ? _a : "";
  var absValue = Math.abs(value);
  var _ref = (_b = String(absValue)) === null || _b === void 0 ? void 0 : _b.split("."),
    _ref2 = _slicedToArray(_ref, 2),
    abs = _ref2[0],
    decimal = _ref2[1];
  var decimalNum = currencyRule.precision !== undefined ? new Array(currencyRule.precision).fill(0).map(function (defaultValue, index) {
    var _a, _b;
    return (_b = (_a = Array.from(decimal !== null && decimal !== void 0 ? decimal : "")) === null || _a === void 0 ? void 0 : _a[index]) !== null && _b !== void 0 ? _b : defaultValue;
  }).join("") : decimal;
  var allCommasRegex = new RegExp(",", "g");
  var absoluteNum = new Intl.NumberFormat(["us", "ko", "ja"], {
    useGrouping: true
  }).format(Number(abs)).replace(allCommasRegex, (_c = currencyRule === null || currencyRule === void 0 ? void 0 : currencyRule.separator) !== null && _c !== void 0 ? _c : ",");
  var groupedValue = "".concat(absoluteNum).concat(decimalNum ? "".concat((_d = currencyRule === null || currencyRule === void 0 ? void 0 : currencyRule.decimal) !== null && _d !== void 0 ? _d : ".").concat(decimalNum) : "");
  var formattedValue = currencyRule.format.replace("!", symbol).replace("#", groupedValue);
  return {
    formattedValue: formattedValue,
    groupedValue: groupedValue,
    symbol: symbol
  };
};
var formatClassifiedCurrency = function formatClassifiedCurrency() {
  var currencyRule = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    format: "#!",
    decimal: ".",
    separator: ",",
    precision: undefined,
    symbol: "",
    currency: ""
  };
  var value = arguments.length > 1 ? arguments[1] : undefined;
  var currency = arguments.length > 2 ? arguments[2] : undefined;
  var _a;
  if (value === 0) {
    return {
      groupedValue: "0",
      formattedValue: currencyRule.format.replace("!", (_a = currencyRule.symbol || currency) !== null && _a !== void 0 ? _a : "").replace("#", "0"),
      symbol: currency !== null && currency !== void 0 ? currency : currencyRule.symbol
    };
  }
  var _formatCurrency = formatCurrency(currencyRule, value, currency),
    formattedValue = _formatCurrency.formattedValue,
    groupedValue = _formatCurrency.groupedValue,
    symbol = _formatCurrency.symbol;
  if (value < 0) {
    return {
      formattedValue: "-".concat(formattedValue),
      groupedValue: "-".concat(groupedValue),
      symbol: symbol
    };
  }
  return {
    formattedValue: formattedValue,
    groupedValue: groupedValue,
    symbol: symbol
  };
};

export { formatClassifiedCurrency, formatCurrency };
